export default {"src":"/_next/static/media/hub-logo.ae15e504.svg","height":24,"width":65,"blurWidth":0,"blurHeight":0};